const minWidth = 600;
const maxWidth = 1024;

const state = {
    mode: "desktop"
}

const getters = {
    mode: state => state.mode
}

const mutations = {
    UPDATE_DEVICE_MODE(state, payload) {
        state.mode = payload;
    }
}

const actions = {
    setDeviceMode({ commit }, value) {
        let mode = "desktop";
        if (value > 0 && value <= minWidth) {
            mode = "mobile";
        } else if (value > minWidth && value <= maxWidth) {
            mode = "tablet";
        }
        commit('UPDATE_DEVICE_MODE', mode);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}